import { render } from "./InterestsSection.vue?vue&type=template&id=62c3f761"
import script from "./InterestsSection.vue?vue&type=script&lang=js"
export * from "./InterestsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__